// extracted by mini-css-extract-plugin
export var emphasizeQuantity = "_ht-3";
export var flatBottomCorners = "_ht-5";
export var productImage = "_ht-0";
export var quantityContainer = "_ht-2";
export var quantityHeader = "_ht-6";
export var tooltip = "_ht-1";
export var wrapAndEllipsesOverflow = "_ht-4";